<script setup>

  const theMenus = [
    {
      route: '/projects',
      name: 'Projects',
      class: 'link'
    },
    {
      route: '/cheats',
      name: 'Cheats',
      full: 'Cheat Sheets',
      class: 'link'
    },
    {
      route: '/blog',
      name: 'Blog',
      class: 'link'
    },
    {
      route: '/about',
      name: 'About',
      class: 'link'
    }
  ]
  const route = useRoute()

</script>

<template>
  <header class="flex justify-between items-start sm:items-center">
    <div class="flex items-center space-x-4">
      <div class="hidden sm:block">
        <NuxtLink to="/" class="text-lg md:text-xl font-semibold p-2 hover:bg-gray-200 dark:hover:bg-gray-800">Pennock Projects</NuxtLink>
      </div>
       
      <nav class="font-mono">
        <ul class="flex flex-row">
          <li key="home" class="inline-block sm:hidden mr-3 sm:mr-4 font-semibold">
            <NuxtLink class="link" to="/">Home</NuxtLink>
          </li>
          <li v-for="menu in theMenus" :key="menu.name" class="mr-3 sm:mr-4">
            <NuxtLink :to="menu.route" :class="route.path.startsWith(menu.route) ? 'current link' : 'link'">
              <span v-if="menu.full">
                <span class="inline-block md:hidden">{{ menu.name }}</span>
                <span class="hidden md:inline-block">{{ menu.full }}</span>
              </span>
              <span v-else>
                {{  menu.name }}
              </span>
            </NuxtLink>
          </li>
        </ul>
        <HubsMenu v-if="route.path.startsWith('/projects') && route.path != '/projects'" class="mt-1"/>
      </nav>

    </div>
    
    <ClientOnly>
      <ColorModeSelector />
    </ClientOnly>
  </header>
</template>

<style scoped>
.link {
  @apply p-1 hover:bg-gray-200 dark:hover:bg-gray-800 text-sm md:text-base
}

.current {
  @apply border border-green-600 border-l-0 border-t-0 border-r-0
}
</style>